import { RouterProvider } from 'react-router-dom';
import '@locales/i18n';
import '@styles/global.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { router } from './router';
import { ToastContainer } from 'react-toastify';
import { MantineProvider } from '@mantine/core';
import '@mantine/dates/styles.css';

const App = () => {
    return (
        <MantineProvider withGlobalClasses>
            <RouterProvider router={router} />
            <ToastContainer autoClose={10000} />
        </MantineProvider>
    );
};

export default App;
